module.exports = __webpack_public_path__ + "pc/static/img/icon2.e7dbf2e5.png";